var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isComponent)?_c(_vm.isComponent,{ref:_vm.getFormFieldRef(),tag:"component",attrs:{"tabIndex":_vm.tabIndex,"formField":_vm.formField,"record":_vm.record,"uniqueFields":_vm.uniqueFields,"isBulkEdit":_vm.isBulkEdit},on:{"selectedValueChanged":_vm.onSelectedValueChanged,"pkFormFieldFocusChanged":_vm.onPkFormFieldFocusChanged}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }